import React, { Component } from 'react';

const GridDataPackages = ({ data }) => {
    return (
        <>
            <div className='row'>

                <div className='col-md-7 col-xs-12 top-table-info'>
                    <div className='row g-0'>
                        <div className='col-md-5 col-xs-12'>
                            <label>Customer</label>
                        </div>
                        <div className='col-md-7 col-xs-12'>
                            <span>{data.customerName}</span>
                        </div>
                    </div>
                    <div className='row g-0'>
                        <div className='col-md-5 col-xs-12'>
                            <label>Transportation Provider</label>
                        </div>
                        <div className='col-md-7 col-xs-12'>
                            <span>{data.carrierName}</span>
                        </div>
                    </div>
                    <div className='row g-0'>
                        <div className='col-md-5 col-xs-12'>
                            <label>Total Number of Packages</label>
                        </div>
                        <div className='col-md-7 col-xs-12'>
                            <span>{data.totalPackages}</span>
                        </div>
                    </div>
                </div>
                <div className='col-md-5 col-xs-12 top-table-info'>
                    <div className='row g-0'>
                        <div className='col-md-6 col-xs-12'>
                            <label>Bill Type</label>
                        </div>
                        <div className='col-md-6 col-xs-12'>
                            <span>{data.billType}</span>
                        </div>
                    </div>
                    <div className='row g-0'>
                        <div className='col-md-6 col-xs-12'>
                            <label>Total Number of Bills</label>
                        </div>
                        <div className='col-md-6 col-xs-12'>
                            <span>{data.totalBills}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GridDataPackages;
